import {createBrowserRouter} from 'react-router-dom';
import { Home,Resume,Projects,Contact } from './pages';
import {PageWrapper} from './Components'

const router = createBrowserRouter([
   {
    path: '/',
    element: <PageWrapper>
        <Home/>
    </PageWrapper>
}, {
    path: '/resume',
    element: <PageWrapper>
        <Resume/>
    </PageWrapper>
},
{
    path: '/projects',
    element: <PageWrapper>
        <Projects/>
    </PageWrapper>
},
{
    path: '/contact',
    element: <PageWrapper>
        <Contact/>
    </PageWrapper>
}
])

export default router;